module.exports = __webpack_public_path__ + "p4_img2.jpg?23897e6c51be26950e54289d8b1a4c1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img2.jpg
// module id = 113
// module chunks = 0